import { useAlarms } from '@hakimo-ui/hakimo/data-access';
import { currentTenantAtom } from '@hakimo-ui/hakimo/util';
import { Selectable, HakimoSpinner } from '@hakimo-ui/shared/ui-base';
import { useAtomValue } from 'jotai';
import { getLatestAlarmSearchParams, REFETCH_INTERVAL } from './util';

interface Props {
  tenants?: Selectable[];
}

export function LatestAlarmTimestamp(props: Props) {
  const { tenants } = props;
  const currentTenant = useAtomValue(currentTenantAtom);
  // Per-tenant routing; see AlarmList.
  const dataVersion = currentTenant?.version;
  const searchParams = getLatestAlarmSearchParams(tenants);
  const { data, isLoading } = useAlarms(
    searchParams,
    REFETCH_INTERVAL,
    undefined,
    false,
    false,
    dataVersion
  );

  const timestamp = data?.items[0]?.timestamp;
  const hasAlarm = !!data?.items[0];

  if (isLoading) {
    return (
      <div className="flex items-center gap-4">
        <label className="dark:text-dark-secondary-text text-sm font-medium text-gray-700">
          Latest Alarm Timestamp:
        </label>
        <div className="dark:bg-dark-bg flex items-center gap-2 bg-gray-50 px-3 py-2 text-sm">
          <HakimoSpinner />
          <span className="text-gray-600 dark:text-gray-300">Loading...</span>
        </div>
      </div>
    );
  }

  if (!hasAlarm || !timestamp) {
    return (
      <div className="flex items-center gap-4">
        <label className="dark:text-dark-secondary-text text-sm font-semibold text-gray-700">
          Latest Alarm Timestamp:
        </label>
        <div className="dark:bg-dark-bg dark:text-dark-secondary-text px-3 py-2 text-sm font-medium text-gray-700">
          Unavailable
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center">
      <label className="dark:text-dark-secondary-text text-sm font-medium text-gray-700">
        Latest Alarm Timestamp :
      </label>
      <div className="dark:bg-dark-bg dark:text-dark-text bg-gray-50 px-3 py-2 text-sm font-semibold text-gray-900">
        {new Date(timestamp).toLocaleString()}
      </div>
    </div>
  );
}

export default LatestAlarmTimestamp;
